import React from 'react';
import { FooterTemplate } from 'themes/components';

function Footer({rootStore}) {
	return <FooterTemplate rootStore={rootStore} />;
}

export default Footer;
